import moment from 'moment';

export const getDefaultDateFrom = () => moment().subtract(30, 'days').format('YYYY-MM-DD');
export const getDefaultDateTo = () => moment().format('YYYY-MM-DD');

export const defaultFilters = {
  sortBy: 'date',
  sortDirection: 'desc',
  dateFrom: getDefaultDateFrom(),
  dateTo: getDefaultDateTo(),
  movementType: [],
  companies: [],
  sharedListIds: [],
  contactScope: '',
};

export const getDefaultFilters = () => ({
  ...defaultFilters,
  dateFrom: getDefaultDateFrom(),
  dateTo: getDefaultDateTo(),
});

export const isDefaultFilters = (filters) => {
  const keys = Object.keys(defaultFilters);
  return keys.every((key) => {
    const defaultValue = defaultFilters[key];
    const currentValue = filters[key];

    if (Array.isArray(defaultValue)) {
      return !currentValue || (Array.isArray(currentValue) && currentValue.length === 0);
    }

    if (defaultValue === null || defaultValue === undefined) {
      return currentValue === null || currentValue === undefined || currentValue === '';
    }

    if (defaultValue === '') {
      return !currentValue || currentValue === '';
    }

    return currentValue === defaultValue;
  });
};
